import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
} from "@tanstack/react-router";
import { CATEGORIES, type Category, type IdeaStatus } from "../shared/types";
import { BoardPage } from "./pages/BoardPage";
import { LoginPage } from "./pages/LoginPage";
import { MoneyPage } from "./pages/MoneyPage";
import { SitesPage } from "./pages/SitesPage";

export interface BoardSearch {
  c: Category | "all";
  s: IdeaStatus;
  item?: string;
}

export interface MoneySearch {
  sub?: string;
}

const rootRoute = createRootRoute({ component: Outlet });

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (search: Record<string, unknown>): BoardSearch => {
    const out: BoardSearch = {
      c: (CATEGORIES as readonly string[]).includes(String(search["c"]))
        ? (search["c"] as Category)
        : "all",
      s: search["s"] === "done" ? "done" : "open",
    };
    if (typeof search["item"] === "string") out.item = search["item"];
    return out;
  },
  component: BoardPage,
});

export const moneyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/money",
  validateSearch: (search: Record<string, unknown>): MoneySearch =>
    typeof search["sub"] === "string" ? { sub: search["sub"] } : {},
  component: MoneyPage,
});

export const sitesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sites",
  component: SitesPage,
});

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([indexRoute, moneyRoute, sitesRoute, loginRoute]),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
